var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permiteEnviarParaAnalise)?_c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-paper-plane fa-lg icon-button mr-1",attrs:{"title":"Enviar para análise"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarEnviarParaAnalise()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }